import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { AuthGuard } from './core/services/auth-guard.service';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';


const routes: Routes = [
  { 
    path: '', 
    redirectTo: "login", 
    pathMatch: 'full' 
  },
  {
    path: 'login',
    component: AuthComponent
  },
  { 
    path: "home", 
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate:[AuthGuard]
  },
  { 
    path: 'notfound', 
    component: PageNotFoundComponent 
  },
  { 
    path: '**', 
    redirectTo: 'notfound' 
  },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
